import { render, staticRenderFns } from "./ChatAttachmentUploadComponent.vue?vue&type=template&id=2cfb2a18&scoped=true&"
import script from "./ChatAttachmentUploadComponent.vue?vue&type=script&lang=ts&"
export * from "./ChatAttachmentUploadComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChatAttachmentUploadComponent.vue?vue&type=style&index=0&id=2cfb2a18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb2a18",
  null
  
)

export default component.exports